import { useLocation } from 'react-router-dom';

import { BaseLink, LinkProps } from './BaseLink';

export const Link = ({ children, state, ...props }: LinkProps) => {
  const { state: locationState } = useLocation();

  return (
    <BaseLink state={{...locationState, ...state}} {...props}>
      {children}
    </BaseLink>
  );
};
